import { Tooltip } from '@mui/material'
import '../assets/css/common.css'
import React, { useState } from 'react'

/**
 * @type {React.FC<{
 *   title: string
 *   placement: TooltipProps['placement']
 *   forceShow: boolean
 *   open?: boolean
 *   onClose?: () => void
 *   useParentWidth?: boolean
 *   arrow?: boolean
 *   slotProps?: TooltipProps['slotProps']
 *   sx?: object
 * }>}
 */
const CustomTooltip = (props) => {
  const {
    children,
    title,
    placement = 'bottom-start',
    forceShow = false,
    open,
    onClose,
    useParentWidth = false,
    arrow = false,
    slotProps = {},
    sx = {}
  } = props

  const childRef = React.useRef(null)

  const [{ client, offset, scroll }, setDimensions] = useState({
    client: 0,
    offset: 0,
    scroll: 0
  })

  function onResize() {
    const el = childRef.current
    if (!el) return

    setDimensions({
      client: el.clientWidth,
      offset: el.offsetWidth,
      scroll: el.scrollWidth
    })
  }

  React.useEffect(() => {
    const resize = new ResizeObserver((entries) => {
      for (const _ of entries) {
        onResize()
      }
    })

    onResize()

    resize.observe(document.body)
    childRef.current && resize.observe(childRef.current)
    return () => {
      resize.disconnect()
    }
  }, [])

  const render = typeof children === 'function' ? children(childRef) : children

  const showTooltip = client < scroll || offset < scroll

  // デフォルトスタイル
  const defaultSx = {
    fontSize: '13px',
    color: '#3150a5',
    backgroundColor: '#fff',
    border: '1px solid rgba(56, 57, 71, 0.45)',
    borderRadius: '6px',
    padding: '8px 14px',
    ...(useParentWidth ? { maxWidth: offset } : {})
  }

  // slotProps.tooltip.sxをマージ
  const mergedTooltipSx = {
    ...defaultSx,
    ...(slotProps.tooltip?.sx || {}),
    ...sx
  }

  const isControlled = open !== undefined
  const hoverDisabled = isControlled || (!forceShow && !showTooltip)

  return (
    <Tooltip
      arrow={arrow}
      disableInteractive={!forceShow}
      disableHoverListener={hoverDisabled}
      disableFocusListener={hoverDisabled}
      disableTouchListener={hoverDisabled}
      open={open}
      onClose={onClose}
      placement={placement}
      slotProps={{
        ...slotProps,
        tooltip: {
          'data-testid': 'tooltip',
          ...slotProps.tooltip,
          sx: mergedTooltipSx
        }
      }}
      title={title}
    >
      {render}
    </Tooltip>
  )
}

export default CustomTooltip
